import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-three-one',
  templateUrl: './c4-four-three-one.component.html',
  styleUrls: ['./c4-four-three-one.component.scss']
})
export class C4FourThreeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
